<template>
  <!-- Edit Dialog -->
  <base-dialog
    v-model="dialog.show"
    max-width="700px"
    min-width="400px"
    scrollable
    @close="onDialogClose"
    :title="`${titleDialog} ${$t('sidebar.datastore.name')}`"
    width="50%"
  >
    <base-form ref="form" lazy-validation @submit.stop="onSubmit">
      <v-row no-gutters>
        <v-col cols="12">
          <field-group
            v-model="dialog.data.name"
            autofocus
            filled
            :rules="nameRules"
            label="Tên hiển thị"
            no-label
          ></field-group>
        </v-col>
        <v-col cols="12" v-if="isCreateDialog">
          <field-group
            item-text="name"
            item-value="value"
            v-model="dialog.data.type"
            filled
            :items="dataStoreTypes"
            :rules="typeRules"
            :error-messages="dialog.error.type"
            label="Loại"
            no-label
            typeInput="v-select"
          >
          </field-group>
        </v-col>
        <v-col
          cols="12"
          v-if="isCreateDialog && dialog.data.type == 'shapefile'"
        >
          <field-group
            item-text="name"
            item-value="code"
            v-model="srs"
            filled
            :items="srsList"
            required
            label="Hệ toạ độ"
            no-label
            typeInput="v-autocomplete"
          >
          </field-group>
        </v-col>
        <v-col v-if="isCreateDialog && isFileUploadType">
          <field-group
            v-model="dialog.data.file"
            :error-messages="dialog.error.file"
            typeInput="field-file-input"
            :rules="fileRules"
            :accept="acceptFile"
            :title="uploadTitle"
          >
          </field-group>
        </v-col>
        <v-col v-if="dialog.data.type == 'api'">
          <div class="d-flex">
            <field-group
              typeInput="v-textarea"
              :disabled="!isCreateDialog"
              rows="2"
              prepend-inner-icon="mdi-link"
              :rules="apiRules"
              style="flex: 1"
              v-model="dialog.data.api"
              :error-messages="dialog.error.api"
              filled
              label="Link api từ MTQG"
              no-label
            >
            </field-group>
            <v-tooltip bottom v-if="!isCreateDialog && !loadingSynApi">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="mx-2 mt-2"
                  fab
                  dark
                  large
                  color="cyan"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  @click="updateApiData(dialog.data)"
                >
                  <v-icon dark>
                    mdi-sync
                  </v-icon>
                </v-btn>
              </template>
              <span>Cập nhật dữ liệu từ API</span>
            </v-tooltip>
          </div>
          <div v-if="!isCreateDialog"
            >Thời gian dữ liệu: {{ dialog.data.time_data | dateTime }}</div
          >
          <div v-if="loadingSynApi">
            <div>Đang cập nhật dữ liệu từ API. Vui lòng đợi</div>
            <v-progress-linear
              indeterminate
              color="yellow darken-2"
            ></v-progress-linear>
          </div>
        </v-col>
      </v-row>
    </base-form>

    <template v-slot:extra-btn>
      <base-button
        color="primary"
        :loading="dialog.loading"
        outlined
        :type-action="dialog.type"
        @click="onSubmit"
      >
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { EDIT_TYPE } from '@constant'
import { API_DATASTORE, API_SRS } from '@api'
import { mapGetters } from 'vuex'
export default {
  components: {},
  props: {
    workspace_id: {
      type: [String, Number],
      required: true,
    },
  },
  data: () => ({
    nameRules: [(v) => !!v || 'Tên không thể bỏ trống'],
    typeRules: [(v) => !!v || 'Loại không thể bỏ trống'],
    fileRules: [(v) => !!v || 'File không thể bỏ trống'],
    apiRules: [(v) => !!v || 'Link API không thể bỏ trống'],
    dialog: {
      show: false,
      loading: false,
      data: {},
      type: EDIT_TYPE.CREATE,
      error: {},
    },
    loadingSynApi: false,
    dataStoreTypes: [
      { name: 'Shapefile', value: 'shapefile' },
      //   { name: 'GeoTIFF (.tif)', value: 'tif' },
      //   { name: 'GeoPDF (.pdf)', value: 'pdf' },
      { name: 'Link API từ MTQG', value: 'api' },
    ],
    srsList: [],
    srs: null,
  }),
  watch: {},
  created() {
    this.fetchSrsList()
  },
  computed: {
    ...mapGetters({
      currentId: 'auth/currentId',
      currentUser: 'auth/currentUser',
    }),
    titleDialog() {
      if (this.isCreateDialog) {
        return this.$i18n.t('actions.add')
      } else {
        return this.$i18n.t('actions.update')
      }
    },
    isCreateDialog() {
      return this.dialog.type == EDIT_TYPE.CREATE
    },
    isFileUploadType() {
      return ['shapefile', 'tif', 'pdf'].includes(this.dialog.data.type)
    },

    acceptFile() {
      if (this.dialog.data.type === 'tif') return '.tif,.tiff'
      if (this.dialog.data.type === 'pdf') return '.pdf'
      return '.zip'
    },

    uploadTitle() {
      if (this.dialog.data.type === 'tif') return 'Tải GeoTIFF'
      if (this.dialog.data.type === 'pdf') return 'Tải GeoPdf'
      return 'Tải Shapefile'
    },
  },
  methods: {
    open(item, type = EDIT_TYPE.CREATE) {
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.dialog.show = true
      this.dialog.type = type
      this.$set(this.dialog, 'data', Object.assign({}, item))
      if (
        item &&
        item.details &&
        item.details.length > 0 &&
        item.details[0].type == 'api'
      ) {
        this.dialog.data.type = 'api'
        this.dialog.data.api = item.details[0].api_link
      }
    },
    onDialogClose() {
      this.dialog = {
        show: false,
        loading: false,
        data: {},
        type: EDIT_TYPE.CREATE,
        error: {},
      }
    },
    async onSubmit() {
      this.dialog.error = {}
      if (!(await this.$refs.form.validate())) return
      try {
        let data = {}
        if (this.dialog.data.type == 'shapefile') {
          data = Object.assign(
            { workspace_id: this.workspace_id, srs: this.srs },
            this.dialog.data
          )
        } else {
          data = Object.assign(
            { workspace_id: this.workspace_id },
            this.dialog.data
          )
        }
        let formData = new FormData()
        for (const key in data) {
          formData.append(key, data[key])
        }

        this.$store
          .dispatch('datastore/callUpload', {
            url: `datastores`,
            data: formData,
            cbWhenComplete: (res) => {
              this.getData()
            },
          })
          .then((res) => {})
        this.onDialogClose()
      } finally {
        this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
    async updateApiData(item) {
      this.loadingSynApi = true
      let res = await API_DATASTORE.sync(item.id)
      this.loadingSynApi = false
      if (res.isDone) {
        this.dialog.data.time_data = res.data.data.time_data
      }
    },
    async fetchSrsList() {
      const res = await API_SRS.list()
      this.srsList = res.data
    },
  },
}
</script>

<style scoped>
.v-btn {
  font-weight: 400;
}
</style>
